import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { appAndriod, appApple, logo } from "../../assets";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookF } from '@fortawesome/free-brands-svg-icons';

const LINKTREE_LINKS = [
    {
        label: "Explore Our Product Catalogue",
        sub: "PDF · Document",
        href: "https://linktr.ee/mainlogixca",
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zm-1 1.5L18.5 9H13V3.5zM6 20V4h5v7h7v9H6z"/>
            </svg>
        ),
    },
    {
        label: "30 Minute Call with Us",
        sub: "Calendly · Josiah Mainlogix",
        href: "https://calendly.com/josiah-mainlogix/mainlogix-technology-canada",
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19 4h-1V2h-2v2H8V2H6v2H5C3.9 4 3 4.9 3 6v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11zM7 11h5v5H7z"/>
            </svg>
        ),
    },
    {
        label: "Registration of Interest",
        href: "https://linktr.ee/mainlogixca",
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 14l-5-5 1.41-1.41L12 14.17l7.59-7.59L21 8l-9 9z"/>
            </svg>
        ),
    },
    {
        label: "GrandeurSmart Security Kit",
        sub: "AI-driven intruder deterrence for unmatched safety",
        href: "https://www.youtube.com/@MainlogixTechnology",
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                <path d="M21.58 7.19c-.23-.87-.91-1.56-1.78-1.79C18.25 5 12 5 12 5s-6.25 0-7.8.4c-.87.23-1.55.92-1.78 1.79C2 8.74 2 12 2 12s0 3.26.42 4.81c.23.87.91 1.56 1.78 1.79C5.75 19 12 19 12 19s6.25 0 7.8-.4c.87-.23 1.55-.92 1.78-1.79C22 15.26 22 12 22 12s0-3.26-.42-4.81zM10 15V9l5.2 3-5.2 3z"/>
            </svg>
        ),
    },
    {
        label: "GrandeurSmart at Web Summit 2025 Vancouver",
        sub: "Live Event",
        href: "https://linktr.ee/mainlogixca",
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 14H9V8h2v8zm4 0h-2V8h2v8z"/>
            </svg>
        ),
    },
    {
        label: "Company Profile",
        sub: "PDF · Document",
        href: "https://linktr.ee/mainlogixca",
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z"/>
            </svg>
        ),
    },
    {
        label: "Check out Our Catalog",
        sub: "1 file · Free",
        href: "https://linktr.ee/mainlogixca",
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                <path d="M21 5c-1.11-.35-2.33-.5-3.5-.5-1.95 0-4.05.4-5.5 1.5-1.45-1.1-3.55-1.5-5.5-1.5S2.45 4.9 1 6v14.65c0 .25.25.5.5.5.1 0 .15-.05.25-.05C3.1 20.45 5.05 20 6.5 20c1.95 0 4.05.4 5.5 1.5 1.35-.85 3.8-1.5 5.5-1.5 1.65 0 3.35.3 4.75 1.05.1.05.15.05.25.05.25 0 .5-.25.5-.5V6c-.6-.45-1.25-.75-2-1zm0 13.5c-1.1-.35-2.3-.5-3.5-.5-1.7 0-4.15.65-5.5 1.5V8c1.35-.85 3.8-1.5 5.5-1.5 1.2 0 2.4.15 3.5.5v11.5z"/>
            </svg>
        ),
    },
    {
        label: "Partner With Us",
        href: "https://linktr.ee/mainlogixca",
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/>
            </svg>
        ),
    },
    {
        label: "Mainlogix — Find Out More",
        href: "http://mainlogix.ca/",
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm6.93 6h-2.95c-.32-1.25-.78-2.45-1.38-3.56 1.84.63 3.37 1.91 4.33 3.56zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2s.06 1.34.14 2H4.26zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56-1.84-.63-3.37-1.9-4.33-3.56zm2.95-8H5.08c.96-1.66 2.49-2.93 4.33-3.56C8.81 5.55 8.35 6.75 8.03 8zM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM14.34 14H9.66c-.09-.66-.16-1.32-.16-2s.07-1.35.16-2h4.68c.09.65.16 1.32.16 2s-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95c-.96 1.65-2.49 2.93-4.33 3.56zM16.36 14c.08-.66.14-1.32.14-2s-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38z"/>
            </svg>
        ),
    },
    {
        label: "Grandeur Smart",
        href: "https://grandeursmart.ca/",
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>
            </svg>
        ),
    },
];

const SOCIAL_LINKS = [
    {
        label: "LinkedIn",
        href: "https://www.linkedin.com/company/mainlogix-technology-canada/",
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <path d="M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.593-11.018-3.714v-2.155z"/>
            </svg>
        ),
    },
    {
        label: "Facebook",
        href: "https://www.facebook.com/mainlogix",
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
            </svg>
        ),
    },
    {
        label: "Instagram",
        href: "https://www.instagram.com/mainlogix/",
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z"/>
            </svg>
        ),
    },
    {
        label: "YouTube",
        href: "https://www.youtube.com/@MainlogixTechnology",
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
            </svg>
        ),
    },
    {
        label: "WhatsApp",
        href: "https://wa.me/2348062081641",
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z"/>
            </svg>
        ),
    },
    {
        label: "X (Twitter)",
        href: "https://x.com/mainlogix",
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.746l7.73-8.835L1.254 2.25H8.08l4.253 5.622 5.911-5.622zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
            </svg>
        ),
    },
    {
        label: "TikTok",
        href: "https://www.tiktok.com/@mainlogix",
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.33-6.34l.04-8.44a8.23 8.23 0 0 0 4.83 1.56V5.01a4.85 4.85 0 0 1-1.1-.32z"/>
            </svg>
        ),
    },
];

function LinktreePopup({ onClose }) {
    return (
        <div
            className="fixed inset-0 z-[9999] flex items-center justify-center"
            style={{ backgroundColor: 'rgba(0,0,0,0.7)' }}
            onClick={onClose}
        >
            <div
                className="relative bg-white rounded-2xl shadow-2xl w-full max-w-md mx-4 max-h-[90vh] overflow-y-auto"
                onClick={e => e.stopPropagation()}
            >
                {/* Header */}
                <div className="bg-red-600 rounded-t-2xl px-6 pt-8 pb-6 text-center">
                    <button
                        onClick={onClose}
                        className="absolute top-4 right-4 text-white hover:text-gray-200 text-2xl font-bold leading-none"
                        aria-label="Close"
                    >
                        ×
                    </button>
                    <img src={logo} alt="Mainlogix" className="h-12 w-auto mx-auto mb-3 brightness-0 invert" />
                    <h2 className="font-poppins font-bold text-white text-lg leading-snug">Mainlogix Technology | IoT</h2>
                    <p className="font-roboto text-red-100 text-sm mt-1 leading-snug">
                        Pioneering IoT with smart home integration for control, privacy, and automation.
                    </p>
                    {/* Social icons */}
                    <div className="flex items-center justify-center gap-3 mt-4 flex-wrap">
                        {SOCIAL_LINKS.map(s => (
                            <a
                                key={s.label}
                                href={s.href}
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label={s.label}
                                className="text-white hover:text-red-200 transition-colors"
                            >
                                {s.icon}
                            </a>
                        ))}
                    </div>
                </div>

                {/* Links */}
                <div className="px-5 py-5 space-y-3">
                    {LINKTREE_LINKS.map(link => (
                        <a
                            key={link.label}
                            href={link.href}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex items-center gap-3 w-full border-2 border-black rounded-xl px-4 py-3 font-poppins font-semibold text-black hover:bg-black hover:text-white transition-colors group"
                        >
                            <span className="text-red-600 group-hover:text-white flex-shrink-0 transition-colors">
                                {link.icon}
                            </span>
                            <span className="flex flex-col text-left">
                                <span className="text-sm leading-tight">{link.label}</span>
                                {link.sub && (
                                    <span className="text-xs font-roboto font-normal text-gray-500 group-hover:text-gray-300 transition-colors">
                                        {link.sub}
                                    </span>
                                )}
                            </span>
                        </a>
                    ))}
                </div>

                {/* Footer */}
                <div className="text-center pb-5">
                    <a
                        href="https://linktr.ee/mainlogixca"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="font-roboto text-xs text-gray-400 hover:text-red-600 transition-colors"
                    >
                        linktr.ee/mainlogixca
                    </a>
                </div>
            </div>
        </div>
    );
}

// ── LinkedIn Feed via Elfsight ──────────────────────────────────────────────
// 1. Create a free account at https://elfsight.com
// 2. Build a "LinkedIn Feed" widget and connect your LinkedIn page
// 3. Copy your widget ID (UUID format) and replace ELFSIGHT_WIDGET_ID below
const ELFSIGHT_WIDGET_ID = 'YOUR_WIDGET_ID';

export default function Footer2() {
    const [linktreeOpen, setLinktreeOpen] = useState(false);

    useEffect(() => {
        if (document.querySelector('script[src*="elfsight.com/platform"]')) return;
        const script = document.createElement('script');
        script.src = 'https://static.elfsight.com/platform/platform.js';
        script.defer = true;
        document.body.appendChild(script);
    }, []);

    return (
        <>
        <div className="py-12 ">
            <div className="grid pt-3 smd:grid-cols-1 md:grid-cols-4 lg:grid-cols-4 gap-2 smd:flex smd:flex-col-reverse smd:gap-6">

                <div>
                    <Link to='/'>
                    <img 
                        src={logo} 
                        alt="Mainlogix" 
                        height={100}
                        width={134}
                        className="smd:h-[50px] smd:w-auto h-[100px] w-[134px]" 
                    />
                    <article className="font-roboto smd:text-[12px] text-[14px] 2xl:text-3xl text-black">{new Date().getFullYear()} mainlogix.io</article>
                    </Link>
                </div>
                
                <div className="lg:border-l-[1px] border-gray-300 smd:pl-0 smd:gap-6 pl-2">
                    <h2 className="font-poppins text-red-600 smd:text-[12px] text-[14px] 2xl:text-3xl font-semibold">ABOUT US </h2>
                    <ul className="list-none">
                        <Link to='/about'>
                            <li className="font-roboto smd:text-[12px] text-[14px] 2xl:text-3xl text-black mt-1">
                                About Us
                            </li>
                        </Link>
                        <Link to='/contact'>
                            <li className="font-roboto smd:text-[12px] text-[14px] 2xl:text-3xl text-black mt-1">
                                Contact & Consult
                            </li>
                        </Link>
                        <Link to='/technologies-tools'>
                            <li className="font-roboto smd:text-[12px] text-[14px] 2xl:text-3xl text-black mt-1">
                                Technologies & Tools
                            </li>
                        </Link>
                        <Link to='/services'>
                            <li className="font-roboto smd:text-[12px] text-[14px] 2xl:text-3xl text-black mt-1">
                                Our Services
                            </li>
                        </Link>
                        <Link to='/products'>
                            <li className="font-roboto smd:text-[12px] text-[14px] 2xl:text-3xl text-black mt-1">
                                Products
                            </li>
                        </Link>
                        <Link to='/partners'>
                            <li className="font-roboto smd:text-[12px] text-[14px] 2xl:text-3xl text-black mt-1">
                                Partners
                            </li>
                        </Link>
                        <Link to='/expertise'>
                            <li className="font-roboto smd:text-[12px] text-[14px] 2xl:text-3xl text-black mt-1">
                                Expertise
                            </li>
                        </Link>
                        <Link to='/privacy-policy'>
                            <li className="font-roboto smd:text-[12px] text-[14px] 2xl:text-3xl text-black mt-1">
                                Privacy Policy
                            </li>
                        </Link>
                    </ul>
                    <h2 className="font-roboto text-red-600 smd:text-[12px] text-[14px] 2xl:text-3xl font-semibold py-3">SOCIAL LINKS </h2>

                    <div className="flex items-center gap-2 flex-wrap">
                        <a href="https://m.facebook.com/" target="_blank" rel="noopener noreferrer">
                            <FontAwesomeIcon 
                                icon={faFacebookF} 
                                size="1x" 
                                color="white" 
                                className="bg-red-600 rounded-full px-3.5 py-3" 
                            />
                        </a>
                        <a href="https://www.linkedin.com/company/mainlogix-technology-canada/?originalSubdomain=ca" target="_blank" rel="noopener noreferrer" className="inline-block">
                            <div className="rounded-full py-3 px-3 bg-red-600">
                                <svg 
                                    xmlns="http://www.w3.org/2000/svg" 
                                    width="15" 
                                    height="auto" 
                                    viewBox="0 0 24 24"
                                    fill="#FFFFFF"
                                >
                                    <path 
                                        d="M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.593-11.018-3.714v-2.155z"    
                                    />
                                </svg>
                            </div>
                        </a>
                        {/* Linktree button */}
                        <button
                            onClick={() => setLinktreeOpen(true)}
                            className="rounded-full py-2.5 px-3 bg-red-600 hover:bg-red-700 transition-colors flex items-center gap-1.5"
                            aria-label="Open Linktree"
                            title="Our Linktree"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="#FFFFFF">
                                <path d="M7.953 15.066c-.08.163-.08.324-.08.486.08.891.81 1.62 1.701 1.62h.162c.486 0 .891-.162 1.134-.567l2.025-3.24v5.832c0 1.054.81 1.863 1.863 1.863s1.863-.81 1.863-1.863V13.365l2.025 3.24c.324.405.729.567 1.134.567h.162c.891 0 1.62-.729 1.701-1.62 0-.162 0-.324-.08-.486l-3.24-5.184 3.078-.405c.81-.08 1.377-.81 1.296-1.62-.08-.81-.81-1.377-1.62-1.296l-3.24.405V3.2c0-1.053-.81-1.863-1.863-1.863s-1.863.81-1.863 1.863v2.025l-3.24-.405c-.81-.08-1.539.486-1.62 1.296-.08.81.486 1.54 1.296 1.62l3.078.405-3.24 5.184z"/>
                            </svg>
                            <span className="font-roboto text-white text-[11px] font-semibold">Linktree</span>
                        </button>
                    </div>
                    <div >
                    <div className="flex items-center justify-start gap-1 flex-row mr-10 pt-3" >
                      <div>
                      <img src={appApple} alt="" className="" />
                      </div>
                      <div>
                      <a href='https://play.google.com/store/apps/details?id=com.grandeursmart.home.android' target="_blank" rel="noopener noreferrer">
                        <img src={appAndriod} alt="Android App" className=""/>
                      </a>
                      </div>
                    </div>
                  </div>
                </div>

                <div >
                    <h2 className="font-poppins text-red-600 smd:text-[12px] text-[14px] 2xl:text-3xl font-semibold">QUICK LINKS </h2>
                    <ul className="list-none">
                        <Link to='/iot-development-services' >
                        <li className="font-roboto smd:text-[12px] text-[14px] 2xl:text-3xl text-black mt-1">
                            IoT Development Services
                        </li>
                        </Link>
                        <Link to='/general-features' >
                        <li className="font-roboto smd:text-[12px] text-[14px] 2xl:text-3xl text-black mt-1">
                            General Features
                        </li>
                        </Link>
                        <Link to='/operating-system-development' >
                        <li className="font-roboto smd:text-[12px] text-[14px] 2xl:text-3xl text-black mt-1">
                            Operating System Development
                        </li>
                        </Link>
                        <Link to='/existing-solutions' >
                        <li className="font-roboto smd:text-[12px] text-[14px] 2xl:text-3xl text-black mt-1">
                            Existing Solutions
                        </li>
                        </Link>
                        <Link to='/iot-product-development-step' >
                        <li className="font-roboto smd:text-[12px] text-[14px] 2xl:text-3xl text-black mt-1">
                            IoT Product Development Steps
                        </li>
                        </Link>
                        <Link to='/smart' >
                            <li className="font-roboto smd:text-[12px] text-[14px] 2xl:text-3xl text-black mt-1">
                                Smart by Mainlogix
                            </li>
                        </Link>
                    </ul>
                </div>
                <div>
                    <h2 className="font-poppins text-red-600 smd:text-[12px] text-[14px] 2xl:text-3xl font-semibold">LINKEDIN FEEDS</h2>
                    <div className="mt-3">
                        {ELFSIGHT_WIDGET_ID !== 'YOUR_WIDGET_ID' ? (
                            <div
                                className={`elfsight-app-${ELFSIGHT_WIDGET_ID}`}
                                data-elfsight-app-lazy="true"
                            />
                        ) : (
                            /* Fallback shown until Elfsight widget ID is configured */
                            <div className="border border-dashed border-gray-300 rounded-xl p-4 text-center">
                                <p className="font-roboto text-[12px] text-gray-500 mb-3">
                                    LinkedIn feed coming soon.
                                </p>
                                <a
                                    href="https://www.linkedin.com/company/mainlogix-technology-canada/posts/?feedView=all"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="inline-flex items-center gap-2 bg-[#0077B5] hover:bg-[#005f94] text-white font-poppins font-semibold text-[12px] px-4 py-2 rounded-lg transition-colors"
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="currentColor">
                                        <path d="M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.593-11.018-3.714v-2.155z"/>
                                    </svg>
                                    View Latest Posts
                                </a>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
        {linktreeOpen && <LinktreePopup onClose={() => setLinktreeOpen(false)} />}
    </>
    );
}
